<template>
  <q-timeline-entry
    :key="date"
    :color="date === 'pinned' ? 'blue-7' : !isFutureDate ? 'teal-7' : 'grey-5'"
    :icon="date === 'pinned' ? 'mdi-pin' : undefined"
  >
    <template #subtitle>
      <span v-if="date !== 'pinned'">{{ $formatDate(date, luxonFormats.SHORT_WORDED_DATE) }}</span>
      <span v-else>Pinned</span>
    </template>

    <component
      :is="getTypeForEntry(item).component"
      v-for="(item, index) in visibleEntries"
      :key="date + '-' + item.id + '-' + index + '-' + item.timeline_type"
      :read-only="readOnly || !!item.timeline_morph"
      :disable-pinning="disablePinning"
      v-bind="getTypeForEntry(item).props(item)"
      @remove="(val) => $emit('remove', item, val)"
      @save="(val) => $emit('save', val)"
      @pin="() => $emit('pin', item)"
    />

    <q-btn
      v-if="!manual && entries.length > visibleEntries.length"
      :label="page === 0 ? 'Load Results' : 'Load More...'"
      no-caps
      size="12px"
      color="blue-7"
      @click="page++"
    />
  </q-timeline-entry>
</template>

<script>
export default {
  props: {
    partialTypes: {
      type: Array,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: true
    },
    disablePinning: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      required: true
    },
    bigDataMode: {
      type: Boolean,
      default: false
    },
    manual: {
      type: Boolean,
      default: false
    },
    entries: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['remove', 'save', 'pin'],
  data () {
    return {
      page: this.bigDataMode ? 0 : 1
    }
  },
  computed: {
    isFutureDate () {
      if (this.date === 'pinned') {
        return false
      }
      return this.luxon.now().endOf('day') < this.luxon.fromSQL(this.date)
    },
    visibleEntries () {
      if (this.manual) {
        return this.entries
      }
      return this.entries.slice(0, this.page * 10)
    }
  },
  methods: {
    getTypeForEntry (item) {
      return this.partialTypes.find(i => i.value === item.timeline_type)
    }
  }
}
</script>
